import { FC } from "react";
import { BREAKPOINTS } from "../constants/common";
import { translation as t } from "../utils/translation";
import { formatNumberWithoutDot } from "../utils/ui";
import Success from "../assets/icons/success.svg";
import { useWindowSize } from "../hooks/useWindowWidth";
interface ResultsHeaderProps {
  loanAmount: number;
  period: number;
}
const ResultsHeader: FC<ResultsHeaderProps> = ({
  loanAmount,
  period,
}: ResultsHeaderProps) => {
  const windowWidth = useWindowSize();
  const { EXTRA_LARGE } = BREAKPOINTS;
  return (
    <div id="resultsHeader" className="flex my-9">
      <img src={Success} />
      <div>
        <h2
          className={`font-bold text-darkBlue xs:flex-col xxl:flex-row ${
            windowWidth < EXTRA_LARGE ? "text-[24px]" : "text-[40px]"
          }`}
        >
          {t.SHOW_RESULTS_TITLE} {t.SHOW_RESULTS_TITLE_2}
        </h2>
        <p
          className={`font-bold text-grey ${
            windowWidth < EXTRA_LARGE ? "text-[16px]" : "text-[22px]"
          }`}
        >{`${t.FOR_LOAN_AMOUNT_OF} ${formatNumberWithoutDot(
          loanAmount.toString()
        )} ${t.SUM_FOR}${period} ${t.YEARS_SUM_IS}:`}</p>
      </div>
    </div>
  );
};
export default ResultsHeader;